import LoadingSpinner from './LoadingSpinner'

interface LoadingCloakProps {
    loading: boolean
}

export default function LoadingCloak({ loading }: LoadingCloakProps) {
    if (!loading) return
    return (
        <div className="loading-cloak">
            <LoadingSpinner />
        </div>
    )
}
